module.exports = __webpack_public_path__ + "assets/images/05HBox.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/05HBox.png
// module id = 1263
// module chunks = 1